import { Pagination, PaginationProps } from "../../../../..";

import styles from "./DataTablePagination.module.scss";

export type DataTablePaginationProps = Pick<
  PaginationProps,
  | "page"
  | "itemsPerPage"
  | "totalItemCount"
  | "showCount"
  | "onPageChange"
  | "onItemsPerPageChange"
  | "itemsPerPageOptions"
>;

export const DataTablePagination = ({
  showCount = true,
  ...props
}: DataTablePaginationProps) => {
  return (
    <Pagination
      className={styles["pagination"]}
      {...props}
      showCount={showCount}
    />
  );
};
